import React from "react";
import {BaseComponent} from "@reapptor-apps/reapptor-react-common";
import {Button, ButtonContainer, ButtonType} from "@reapptor-apps/reapptor-react-components";
import StripeKycStatusItem from "@/models/server/stripe/kycstatus/StripeKycStatusItem";
import StripeKycStatus from "@/models/server/stripe/kycstatus/StripeKycStatus";
import TransformProvider from "@/providers/TransformProvider";
import Localizer from "../../../../localization/Localizer";

import styles from "./InProgress.module.scss";
import kycStyles from "../Kyc.module.scss";

interface IInProgressProps {
    stripeKycStatus: StripeKycStatus;
    onButtonClick: (sender: InProgress) => Promise<void>;
}

interface IInProgressState {
}

export default class InProgress extends BaseComponent<IInProgressProps, IInProgressState> {

    state: IInProgressState = {
    };

    public get stripeKycStatus(): StripeKycStatus {
        return this.props.stripeKycStatus;
    }

    public render(): React.ReactNode {
        return (
            <div className={this.css(kycStyles.statusContainer, styles.inProgress)}>

                <div className={kycStyles.text}>

                    <span>{Localizer.mobileKycPageInProgressStartVerificationMessageSpan}</span>

                    <div className={kycStyles.list}>
                        
                        <h6>
                            {Localizer.mobileKycPageInProgressInformationListHeading}
                        </h6>

                        <ul>
                            {
                                (
                                    this.stripeKycStatus.currentlyDueDocumentItems?.map((item: StripeKycStatusItem) =>
                                        <li>{TransformProvider.localizeStripeKycStatusItem(item)}</li>
                                    )
                                )
                            }

                        </ul>
                        
                    </div>

                </div>

                <div className={kycStyles.expander}/>

                <ButtonContainer>

                    <Button type={ButtonType.Primary}
                            icon={{name:"fas fa-arrow-alt-right"}}
                            label={Localizer.genericContinue}
                            onClick={() => this.props.onButtonClick(this)}
                    />

                </ButtonContainer>

            </div>
        );
    }
}